import { render, staticRenderFns } from "./BatchLotUpImageTd.vue?vue&type=template&id=506300e0&scoped=true"
import script from "./BatchLotUpImageTd.vue?vue&type=script&lang=js"
export * from "./BatchLotUpImageTd.vue?vue&type=script&lang=js"
import style0 from "./BatchLotUpImageTd.vue?vue&type=style&index=0&id=506300e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506300e0",
  null
  
)

export default component.exports